import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";


import {
  staffClaimApplicationsColumns,
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import { StaffClaimApplications } from "../../../data/Queries/HRmanagement/leavemanagement";
import ClaimApplicationForm from "../StaffClaimByUser/form";


const base_url = HRService.uri;
const actions = {
  entity: "Staff Claim Approvals",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  approve: {
    key: "APPROVE_LEAVE",
    button_name: "Approve Staff Claim",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  decline: {
    key: "REJECT_LEAVE",
    button_name: "Reject Staff Claim",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },

  dataObject: {
    inputObjectName: "approveDeclineStaffClaimApplication",
    inputSubObjectName: "applicationsApprovals",
    inputFields: ["applicationId", "userId", "comments"],
  },
  actionName: " Staff Claim ",
  showStatus: true,
};
function StaffClaimsTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Staff Claims"
          subtitle="View all Staff Claims, approve or decline"
          columns={staffClaimApplicationsColumns}
          query={StaffClaimApplications}
          actions={actions}
          base_url={base_url}
          FormComponent={ClaimApplicationForm}
        />
      </>
    </Box>
  );
}

export default StaffClaimsTable;
